export default {"src":"/_next/static/media/ageGroup.65042880.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};